import styled from "@emotion/styled"
import { DataGrid } from "@mui/x-data-grid"

export const StickyDataGrid = styled(DataGrid)(() => ({
    '& .MuiDataGrid-columnHeaders': {
        position: "sticky",
        top: 0,
        background: 'white',
        // Replace background colour if necessary
        // Display header above grid data, but below any popups
        zIndex: 1000,
    },
    '& .MuiDataGrid-virtualScroller': {
        // Undo the margins that were added to push the rows below the previously fixed header
        marginTop: "1 !important",
        // position: 'relative'
    },
    '& .MuiDataGrid-main': {
        // Not sure why it is hidden by default, but it prevented the header from sticking
        overflow: "visible",
        width: 'auto'

    }
}))